import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";
import ScrollToTop from "./routes/ScrollToTop";
import GoTop from "./components/_App/GoTop";

export default function App() {
  return (
    <BrowserRouter>
    <ScrollToTop />
      <AppRoutes />
       <GoTop scrollStepInPx="100" delayInMs="10.50" />
    </BrowserRouter>
  );
}
